import {
    DETAILS_RECIEVED,
} from '../../youwell-common/ReduxStoreHelper';

export const PREVIEW_ACTION_PREFIX = 'PREVIEW';
export const PREVIEW_TASK_RECEIVED = `${PREVIEW_ACTION_PREFIX}/${DETAILS_RECIEVED}`;

export const PUBLIC_ACTION_PREFIX = 'PUBLIC';
export const PUBLIC_PROGRAM_RECEIVED = `${PUBLIC_ACTION_PREFIX}/${DETAILS_RECIEVED}`;
